// extracted by mini-css-extract-plugin
module.exports = {"Alert":"Alert_Alert__13CC3","container":"Alert_container__1Hiqq","root-container":"Alert_root-container__o-FTv"};